import { ValidationSchema } from 'validation-schema-library';

export const getInterruptionCreateValidationSchema = async (): Promise<ValidationSchema> => ({
  recipient: {
    type: 'string',
    required: true,
  },
  message: {
    type: 'string',
    required: true,
  },
});
